angular
    .module('festzelt-os.modules.tickets.main', [
        'ui.router',
        'festzelt-os.components'
    ]);

// Controllers

// Factories
require('./factories/ticket');

// Stores
require('./store/tickets');



// WEBPACK FOOTER //
// ./src/app/modules/tickets/main/module.js